<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in comList" :label="item.title" :name="item.name" lazy
        :key="item.name">
      </el-tab-pane>
      <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" prentType="FBA" :tableType="tableType"
        :forwarder="forwarder" :forwarderCompany="forwarderCompany" ref="InterForm" />
      <div style="margin-bottom: 10px;text-align: left;" v-if="activeName == 'AlreadyProduced'">
        <el-button type="primary" @click="toInvoiceExport">导出</el-button>
      </div>
      <InterList :tableType="tableType" @refeash="refeash" :dataSource="dataSource" :clean='clean'
        @pageChange="pageChangeCall" @selectChange="selectChangeCall" prentType="FBA" ref="interlist"
        :forwarder="forwarder" :total="query.total"></InterList>
    </el-tabs>
  </div>
</template>

<script>
import InterForm from './components/InterForm'
import InterList from "./components/InterList";
import { getInvoicePage, getInvoiceForwarder, getForwarderCompany, invoiceExport } from "@/apis/outStock";
export default {
  title: '大包发货',
  name: "largeBagShip",
  components: {
    InterForm,
    InterList
  },
  data() {
    return {
      activeName: 'ToBeProduced',
      forwarder:[],
      forwarderCompany: [],
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      paramsCache: {},
      clean: false,
      selectedRows: [],
      dataSource: [],
      tableType: 'ToBeProduced',
    }
  },
  created() {
  },
  computed: {
    comList: function () {
      return [{ name: 'ToBeProduced', title: '发票待制作' }, { name: 'AlreadyProduced', title: '发票已制作' }]
    }
  },
  methods: {
    handleClick(e) {
      this.tableType = e.name
      this.queryHandler()
    },
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    refeash() {
      console.log(777)
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    getDataSource: function () {
      console.log(999, this.tableType)
      const invoiceStatus = ['ToBeProduced', 'AlreadyProduced'].indexOf(this.tableType)
      // 获取列表数据
      this.selectedRows = [];
      const params = {
        ...this.query,
        pageNum: this.query.current,
        invoiceStatus,
        /** 大件普通 */
        deliveryType: 1

      };
      this.paramsCache = params
      this.clean = true;
      getInvoicePage(params)
        .then((res) => {
          const { records=[], total=0} =  res?.data || {}
          // const {
          //   data: { deliveryReviewPage: { total = 0, records = [] } },
          // } = res;
          console.log(9999, res?.data)
          this.dataSource = records
          this.query.total = total
          // console.log(9996669, res)
        })
        .finally((_) => {
          this.clean = false;
        });
    getInvoiceForwarder({
      invoiceStatus: this.tableType == 'ToBeProduced'?0:1,
        deliveryType:1
      }).then(res=>{
        if(res.code == 0){
          this.forwarder = res.data
          if(res.data.length == 0){
            this.$message.warning('货代渠道请求失败')
          }
        }
      }),
      getForwarderCompany({
        invoiceStatus: this.tableType == 'ToBeProduced'?0:1,
          deliveryType:1
      }).then(res => {
          this.forwarderCompany = res.data
          if(res.data.length == 0){
            this.$message.warning('货代公司请求失败')
          }
      })
    },
    toInvoiceExport(){
      console.log('toInvoiceExport')
      let params
      if(this.selectedRows.length){
        params = {
          logisticsCodeList: this.selectedRows.map(v => {
            return v.logisticsCode
          })
        }
      }else{
        params = this.paramsCache
      }
      invoiceExport(params).then(res => {
        console.log(res)
        if(res.code == 0){
          this.$message.success('导出成功，请前往报表-数据导出中下载表格')
        }
      })
    }
  },
}
</script>